import React, {useEffect, useRef, useState} from 'react';
import styles from './ModalDialog.module.css';
import CloseXButton from '../../uiToolkit/Buttons/CloseXButton/CloseXButton';

interface ModalDialogProps {
  isLoading?: boolean;
  loadingText?: string;
  onClose?: () => void;
  children: React.ReactNode;
}

const ModalDialog: React.FC<ModalDialogProps> = ({
  isLoading = false,
  loadingText,
  onClose,
  children,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  const [size, setSize] = useState<{width: number; height: number}>({
    width: 300,
    height: 100,
  });

  useEffect(() => {
    if (!contentRef.current) return;

    const observer = new ResizeObserver(entries => {
      for (const entry of entries) {
        const {width, height} = entry.contentRect;
        setSize({width, height});
      }
    });

    observer.observe(contentRef.current);

    return () => observer.disconnect();
  }, [isLoading, children]);

  return (
    <div className={styles.overlay} onClick={() => onClose?.()}>
      <div
        ref={containerRef}
        className={styles.dialog}
        style={{
          width: size.width,
          height: size.height,
          transition: 'width 0.4s ease, height 0.4s ease',
          overflow: 'hidden',
        }}
        onClick={e => e.stopPropagation()}>
        {onClose && <CloseXButton onClick={() => onClose?.()} />}
        <div ref={contentRef} className={styles.contentWrapper}>
          {isLoading ? (
            <div className={styles.loading}>
              <div className={styles.spinner} />
              {loadingText && (
                <p className={styles.loadingText}>{loadingText}</p>
              )}
            </div>
          ) : (
            children
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalDialog;
